import React from 'react';
import styled from 'styled-components';

import type { CalendarMessageType } from '@/types/calendar';

import { InfoOutline } from '@/assets/icons';
import { CALENDAR_MESSAGE_TYPE_TO_COLORS } from '@/constants/calendar';

interface IProps {
  message: string;
  type: CalendarMessageType;
}

const CalendarMessage = ({ message, type }: IProps): React.ReactElement => {
  const { color, bgColor } = CALENDAR_MESSAGE_TYPE_TO_COLORS[type];

  return (
    <CalendarInfo color={color} bgColor={bgColor}>
      <Icon color={color} />
      {message}
    </CalendarInfo>
  );
};

export { CalendarMessage };

const CalendarInfo = styled.div<{ color: string; bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: ${({ color }) => color};
  border-radius: 4px;
`;

const Icon = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  background-repeat: no-repeat;
  background-size: contain;
  mask-image: url(${InfoOutline});
  mask-size: contain;
  mask-repeat: no-repeat;
  min-width: 16px;
  min-height: 16px;
  align-self: baseline;
  margin: 4px 8px;
`;
